import { Component, OnInit } from '@angular/core';
import {MenuController, ModalController} from "@ionic/angular";

@Component({
  selector: 'app-emergency-request-center',
  templateUrl: './emergency-request-center.component.html',
  styleUrls: ['./emergency-request-center.component.scss'],
})
export class EmergencyRequestCenterComponent implements OnInit {
  tnc: string = "tc";
  constructor(private modalController: ModalController,private menu: MenuController) { }

  ngOnInit() {}

  dismiss(){
    this.modalController.dismiss();
  }
  ionViewWillEnter() {
    this.menu.enable(false);
  }
  ionViewWillLeave() {
    this.menu.enable(true);
  }

}
